module.exports = __webpack_public_path__ + "img/BorrowList2.fdf73bd2.svg";